import React from "react";
import styles from "./TextInput.module.css";

export default function TextInput({
  value,
  onChange,
  placeholder = "",
  type = "text",
  inputMode,
  pattern,
  maxLength,
  autoComplete,
  onBlur,
  className = "",
  ...rest
}) {
  return (
    <input
      className={[styles.input, className].join(" ")}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type={type}
      inputMode={inputMode}
      pattern={pattern}
      maxLength={maxLength}
      autoComplete={autoComplete}
      onBlur={onBlur}
      {...rest}
    />
  );
}